<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>
  <app-unsaved-changes-dialog></app-unsaved-changes-dialog>
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Edit Third-Party Integration"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Edit Third-Party Integration Details'"
    [altColor]="false"
    style="width: 300px"
  >
  </aw-divider>
  @if (integrationInfo) {
  <div>
    <div class="form-container">
      @for (item of integrationTextForms(); track $index) {
      <app-aw-text-form
        class="input"
        [readOnly]="item.readOnly"
        [required]="item.required"
        [title]="item.title"
        [value]="item.value"
        [multiline]="!!item.isName"
        [maxCharacters]="item.isName ? nameMaxLength : null"
        [allowedPattern]="item.isName ? namePattern : null"
        [patternMessage]="namePatternMessage"
        (textEntry)="item.textEntryActionHandler($event)"
      ></app-aw-text-form>
      }

      <!-- Integration Status Field -->
      @if (organization === 'assetworks-employee') {
      <app-aw-dropdown-form
        class="input"
        [options]="statusOptions()"
        title="Status"
        [label]="integrationStatusInput"
        (currentOption)="onIntegrationStatusSelected($event)"
      ></app-aw-dropdown-form>
      } @else {
      <app-aw-text-form
        class="input"
        [readOnly]="true"
        [required]="false"
        title="Status"
        [value]="integrationStatusInput"
      ></app-aw-text-form>
      }
    </div>

    <div class="api-auth-details-container">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'API Authentication'"
        [altColor]="true"
      >
      </aw-divider>

      @if (organization === 'assetworks-employee') {
      <app-aw-dropdown-form
        class="singular-input"
        [options]="authTypeOptions()"
        title="Authentication Type"
        [label]="apiAuthTypeInput"
        (currentOption)="onIntegrationAuthTypeSelected($event)"
      ></app-aw-dropdown-form>
      } @else {
      <app-aw-text-form
        class="singular-input"
        [readOnly]="true"
        [required]="false"
        title="Authentication Type"
        [value]="apiAuthTypeInput"
      ></app-aw-text-form>
      }

      @if (apiAuthTypeInput) {
      <app-aw-auth-form
        [authType]="apiAuthTypeValue"
        [values]="selectedApiAuthValues"
        [editMode]="true"
        [authenticationVersion]="'api'"
        (valuesChangedEvent)="onApiAuthValuesChanged($event)"
      ></app-aw-auth-form>
      }
    </div>

    <div class="employee-auth-details-container">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Third-Party Employee Authentication'"
        [altColor]="true"
      >
      </aw-divider>

      @if (organization === 'assetworks-employee') {
      <app-aw-dropdown-form
        class="singular-input"
        [options]="authTypeOptions()"
        title="Authentication Type"
        [label]="employeeAuthTypeInput"
        (currentOption)="onEmployeeAuthTypeSelected($event)"
      ></app-aw-dropdown-form>
      } @else {
      <app-aw-text-form
        class="singular-input"
        [readOnly]="true"
        [required]="false"
        title="Authentication Type"
        [value]="employeeAuthTypeInput"
      ></app-aw-text-form>
      }

      @if (employeeAuthTypeInput) {
      <app-aw-auth-form
        [authType]="employeeAuthTypeValue"
        [values]="selectedEmployeeAuthValues"
        [editMode]="true"
        [authenticationVersion]="'employee'"
        (valuesChangedEvent)="onEmployeeAuthValuesChanged($event)"
      ></app-aw-auth-form>
      }
    </div>

    @if (organization === 'assetworks-employee' && userPermissions['isAdministrator']) {
    <div class="client-secret-table" style="padding-top: 2rem;">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Third-Party Integration Secrets'"
        [altColor]="false"
        [altColor]="true"
      >
      </aw-divider>
      <div class="table-form-container" [ngClass]="container_theme()">
        <Button AwButton (click)="openAddIntegrationSecretDialog = true"
          >Add</Button
        >
      </div>
      <aw-table
        [columnsDefinition]="secretsColumnsDefinition"
        [tableData]="secretsTableData()"
        [sortDisabled]="false"
      >
      </aw-table>
      <aw-dialog
        [visible]="openAddIntegrationSecretDialog"
        [formFieldsData]="formFieldsData()"
        [dialogOptions]="addSecretDialogOptions()"
        (primaryAction)="addSecretFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('add')"
        ariaLabel="Add client secret"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openDeleteIntegrationSecretDialog"
        [dialogOptions]="deleteSecretDialogOptions()"
        (primaryAction)="deleteSecretFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('delete')"
        ariaLabel="Delete client secret"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openClientSecretDialog"
        [formFieldsData]="clientSecretFormFields"
        [dialogOptions]="clientSecretDialogOptions()"
        (primaryAction)="dialogFormCloseHandler('client-secret')"
        ariaLabel="Client secret created"
      >
      </aw-dialog>
    </div>
    }
  </div>
  }
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
